import { onPageIn, onMount, onDestroy } from '@/modules/_'

export default function (element: HTMLElement, dataset: DOMStringMap) {
  function createSlider(sliderType) {
    const slider = document.querySelector(`[data-slider="${sliderType}"]`)
    const prevBtn = document.querySelector(
      `[data-${sliderType}-slider-ctrl="prev"]`
    )
    const nextBtn = document.querySelector(
      `[data-${sliderType}-slider-ctrl="next"]`
    )

    if (!slider || !prevBtn || !nextBtn) return

    let currentIndex = 0

    // Get the width of the first child (card width)
    function getCardWidth() {
      const firstCard = slider.children[0]
      return firstCard ? firstCard.offsetWidth : 0
    }

    // Get total number of cards
    function getTotalCards() {
      return slider.children.length
    }

    // Get number of visible cards (container width / card width)
    function getVisibleCards() {
      const containerWidth = slider.parentElement.offsetWidth
      const cardWidth = getCardWidth()
      return cardWidth > 0 ? Math.floor(containerWidth / cardWidth) : 1
    }

    // Update button states
    function updateButtonStates() {
      const totalCards = getTotalCards()
      const visibleCards = getVisibleCards()
      const maxIndex = Math.max(0, totalCards - visibleCards)

      // Disable prev button at start
      prevBtn.style.opacity = currentIndex <= 0 ? '0.5' : '1'
      prevBtn.style.pointerEvents = currentIndex <= 0 ? 'none' : 'auto'

      // Disable next button at end
      nextBtn.style.opacity = currentIndex >= maxIndex ? '0.5' : '1'
      nextBtn.style.pointerEvents = currentIndex >= maxIndex ? 'none' : 'auto'
    }

    // Move slider
    function moveSlider(direction) {
      const cardWidth = getCardWidth()
      const totalCards = getTotalCards()
      const visibleCards = getVisibleCards()
      const maxIndex = Math.max(0, totalCards - visibleCards)

      if (cardWidth === 0) return

      if (direction === 'next' && currentIndex < maxIndex) {
        currentIndex++
      } else if (direction === 'prev' && currentIndex > 0) {
        currentIndex--
      } else {
        return // Don't move if at boundaries
      }

      const newPosition = -(currentIndex * cardWidth)
      slider.style.transform = `translateX(${newPosition}px)`
      slider.style.transition = 'transform 0.3s ease-out'

      updateButtonStates()
    }

    // Initialize button states
    updateButtonStates()

    // Update on window resize
    window.addEventListener('resize', updateButtonStates)

    // Event listeners
    nextBtn.addEventListener('click', () => moveSlider('next'))
    prevBtn.addEventListener('click', () => moveSlider('prev'))
  }

  onMount(() => {
    createSlider('podcast')
    createSlider('news')
  })

  onDestroy(() => {})
}
